export default {"src":"__ASTRO_ASSET_IMAGE__D1$bruCB__","width":48,"height":48,"format":"svg"}